var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiltrar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m1.4766 0.16211a0.87704 0.87704 0 0 0-0.7207 1.375l7.8848 11.379v10.045a0.87704 0.87704 0 0 0 1.3203 0.75781l4.7656-2.7891a0.87704 0.87704 0 0 0 0.43359-0.75781v-7.6328l8.0684-10.982a0.87704 0.87704 0 0 0-0.70508-1.3945zm1.6758 1.7539h17.639l-7.2148 9.8164a0.87704 0.87704 0 0 0-0.16992 0.51953v7.418l-3.0117 1.7617v-8.791a0.87704 0.87704 0 0 0-0.15625-0.49805z",
    color: "#000000",
    fill: "#7fb539",
    strokeLinejoin: "round",
    style: {
      InkscapeStroke: "none"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltrar);
export default __webpack_public_path__ + "static/media/filtrar.f953c47a.svg";
export { ForwardRef as ReactComponent };